export default () => ({
    restrict: 'A',
    require: 'ngModel',
    link(scope, elem, attrs, ngModelCtrl) {
        elem.bind("keyup", function (e) {
            if (e.keyCode === 13) {
                scope.$apply(function () {
                    ngModelCtrl.$commitViewValue();
                });
            }
        });
    }
});